import React from 'react'
// themes
import { CloseButton } from './views'

export const getSnackbarCloseButton = (key: string | number, closeSnackbar: (key: string | number) => void, title = 'OK', additionalHandler?: () => void) => {
  const onCloseCLick = () => {
    additionalHandler?.()
    closeSnackbar(key)
  }

  return (
    <CloseButton onClick={onCloseCLick}>
      {title}
    </CloseButton>
  )
}
